var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-menu_button pc_none",class:_vm.isMenuOpen ? 'active' : '',on:{"click":function($event){return _vm.toggleActivation()}}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }